import { AerosoftCrjMarketingSeo } from "../../../content/templateMarketing/aerosoft-crj-seo";
import { AircraftAddonTemplate } from "../../../lib/model/addonTemplate";
import aerosoftCrjImage from "../../images/templates/aerosoft-crj.jpg";

export const aerosoftCrjTemplate: AircraftAddonTemplate = {
  type: "aircraft",
  title: "Aerosoft CRJ",
  id: "aerosoft-crj",
  platforms: ["msfs", "p3d"],
  image: aerosoftCrjImage,
  infoMarketingBlurb: AerosoftCrjMarketingSeo,
  content: [
    {
      title: "Safety Check",
      roles: ["cockpitPreparation", "beforeFlightStart"],
      content: [
        {
          item: "Circuit Breakers",
          setting: "Closed",
        },
        {
          item: "Nosewheel Steering Switch",
          setting: "Off",
        },
        {
          item: "Hydraulic Pumps",
          setting: "Off",
        },
        {
          item: "Landing Gear Lever",
          setting: "Down",
        },
        {
          item: "Flight Spoiler Lever",
          setting: "Retracted",
        },
        {
          item: "Slats / Flaps Lever",
          setting: "Set",
        },
        {
          item: "Radar",
          setting: "Off",
        },
        {
          item: "ADG Manual Release",
          setting: "Stowed",
        },
        {
          item: "Emergency Flap Switch",
          setting: "Off",
        },
        {
          item: "Battery Master Switch",
          setting: "On",
        },
        {
          item: "APU",
          setting: "As Required",
        },
        {
          item: "AC Electrics",
          setting: "As Required",
        },
        {
          item: "IRS",
          setting: "NAV",
        },
        {
          item: "Emergency Equipment",
          setting: "Checked",
        },
        {
          item: "Gear and Safety Pins",
          setting: "On Board",
        },
        {
          item: "Airplane Documents",
          setting: "Checked",
        },
        {
          item: "Hydraulic 3A Pump",
          setting: "As Required for APU",
        },
        {
          item: "FMS Initialization",
          setting: "Complete",
        },
      ],
    },
    {
      title: "Originating Check",
      roles: ["cockpitPreparation", "beforeFlightStart"],
      content: [
        {
          item: "Crew Oxygen Masks",
          setting: "Checked / _____ PSI",
        },
        {
          item: "Audio Warning Panel",
          setting: "Checked",
        },
        {
          item: "Electrical Power Panel",
          setting: "Checked",
        },
        {
          item: "Fire Detection / Firex Monitor Test",
          setting: "Complete",
        },
        {
          item: "External Lights Panel",
          setting: "Checked",
        },
        {
          item: "Fuel Panel",
          setting: "Checked",
        },
        {
          item: "Bleed Air Panel",
          setting: "Checked",
        },
        {
          item: "APU Panel",
          setting: "As Required",
        },
        {
          item: "Start Panel",
          setting: "Checked",
        },
        {
          item: "Hydraulic Panel",
          setting: "Checked, Auto, On (3A)",
        },
        {
          item: "ELT Switch",
          setting: "Arm / Reset",
        },
        {
          item: "Cabin Pressure Panel",
          setting: "Checked",
        },
        {
          item: "Air Conditioning Panel",
          setting: "Checked",
        },
        {
          item: "Anti-Ice Panel",
          setting: "Checked, Complete",
        },
        {
          item: "Windshield Heat",
          setting: "Low",
        },
        {
          item: "Emergency Lights",
          setting: "Armed",
        },
        {
          item: "Standby Compass",
          setting: "Checked",
        },
        {
          item: "Nosewheel Steering Switch",
          setting: "Off",
        },
        {
          item: "Clocks",
          setting: "Set",
        },
      ],
    },
    {
      title: "Originating Check (Contd)",
      roles: ["cockpitPreparation", "beforeFlightStart"],
      content: [
        {
          item: "Instrument Panels",
          setting: "Checked",
        },
        {
          item: "Upper Pedestal",
          setting: "Checked",
        },
        {
          item: "Thrust Lever Quadrant",
          setting: "Checked",
        },
        {
          item: "Avionics / Radio Tuning Panels",
          setting: "Checked",
        },
        {
          item: "Trims",
          setting: "Checked",
        },
        {
          item: "Yaw Damper",
          setting: "Engage",
        },
        {
          item: "Source Select Panel",
          setting: "Norm",
        },
      ],
    },
    {
      title: "Before Start Check",
      roles: ["beforeFlightStart"],
      content: [
        {
          item: "Passenger Signs",
          setting: "On",
        },
        {
          item: "Landing Elevation",
          setting: "Set",
        },
        {
          item: "Altimeters",
          setting: "__,___ Feet",
        },
        {
          item: "FMS",
          setting: "Checked, Set",
        },
        {
          item: "IRS",
          setting: "Aligned, NAV",
        },
        {
          item: "Radios and Nav Aids",
          setting: "Set",
        },
        {
          item: "Take-off Briefing",
          setting: "Complete",
        },
      ],
    },
    {
      title: "Cleared to Start Check",
      roles: ["beforePushback", "beforeEngineStart"],
      content: [
        {
          item: "Personal Electronic Devices",
          setting: "Off",
        },
        {
          item: "APU",
          setting: "On",
        },
        {
          item: "Electrics",
          setting: "Checked",
        },
        {
          item: "Take-off Data",
          setting: "Set",
        },
        {
          item: "Doors",
          setting: "Closed / Locked",
        },
        {
          item: "Beacon",
          setting: "On",
        },
        {
          item: "Fuel Pumps and Quantity",
          setting: "On, ______ kg/lbs",
        },
        {
          item: "Hydraulic Pumps",
          setting: "Auto / On",
        },
        {
          item: "Parking Brake",
          setting: "As Required",
        },
      ],
    },
    {
      title: "After Start Check",
      roles: ["afterEngineStart"],
      content: [
        {
          item: "Generators",
          setting: "Auto",
        },
        {
          item: "Electrics",
          setting: "Checked",
        },
        {
          item: "Bleed Valves",
          setting: "Auto",
        },
        {
          item: "Packs",
          setting: "On",
        },
        {
          item: "APU",
          setting: "As Required",
        },
        {
          item: "Anti-Ice",
          setting: "As Required",
        },
        {
          item: "Nosewheel Steering",
          setting: "Armed",
        },
      ],
    },
    "page-break",
    {
      title: "Taxi Check",
      roles: ["beforeTaxi", "taxi"],
      content: [
        {
          item: "Slats / Flaps",
          setting: "___ Indicating",
        },
        {
          item: "Flight Controls",
          setting: "Checked",
        },
        {
          item: "Trims",
          setting: "Green & ____ Units",
        },
        {
          item: "Thrust Reversers",
          setting: "Armed",
        },
        {
          item: "Flight Instruments",
          setting: "Checked",
        },
        {
          item: "Brake Temp",
          setting: "Checked",
        },
      ],
    },
    {
      title: "Before Take-off Check",
      roles: ["beforeTakeoff"],
      content: [
        {
          item: "Lights and Strobes",
          setting: "On",
        },
        {
          item: "Fuel, XFlow",
          setting: "Manual",
        },
        {
          item: "Flight Attendant",
          setting: "Advised",
        },
        {
          item: "Transponder / TCAS",
          setting: "On, Set",
        },
        {
          item: "Radar / Terrain Display",
          setting: "Set",
        },
        {
          item: "CAS",
          setting: "Checked",
        },
      ],
    },
    {
      title: "Climb Check",
      roles: ["climbOut"],
      content: [
        {
          item: "Fuel, XFlow",
          setting: "Auto",
        },
        {
          item: "Bleeds and APU",
          setting: "Set",
        },
        {
          item: "Thrust Reversers",
          setting: "Off",
        },
        {
          item: "CAS",
          setting: "Checked",
        },
      ],
    },
    {
      title: "Descent Check",
      roles: ["beforeDescent"],
      content: [
        {
          item: "Landing Elevation",
          setting: "Set",
        },
        {
          item: "Fuel",
          setting: "Checked",
        },
        {
          item: "TCAS",
          setting: "Set",
        },
        {
          item: "Radar",
          setting: "As Required",
        },
        {
          item: "CAS",
          setting: "Checked",
        },
        {
          item: "Landing Data",
          setting: "Set",
        },
        {
          item: "Approach Briefing",
          setting: "Complete",
        },
      ],
    },
    {
      title: "Before Landing Check",
      roles: ["approach"],
      content: [
        {
          item: "Flight Attendant",
          setting: "Advised",
        },
        {
          item: "Passenger Signs",
          setting: "On",
        },
        {
          item: "Thrust Reversers",
          setting: "Armed",
        },
        {
          item: "Landing Gear",
          setting: "Down",
        },
        {
          item: "Flaps",
          setting: "___ Indicating",
        },
      ],
    },
    {
      title: "After Landing Check",
      roles: ["afterLanding"],
      content: [
        {
          item: "APU",
          setting: "As Required",
        },
        {
          item: "Transponder / Radar",
          setting: "Standby / Off",
        },
        {
          item: "Flaps",
          setting: "Up / Zero",
        },
        {
          item: "Lights and Strobes",
          setting: "Set",
        },
        {
          item: "Probes",
          setting: "Off",
        },
      ],
    },
    {
      title: "Shutdown Check",
      roles: ["shutdown"],
      content: [
        {
          item: "Parking Brake",
          setting: "As Required",
        },
        {
          item: "Seat Belts",
          setting: "Off",
        },
        {
          item: "Thrust Levers",
          setting: "Shutoff",
        },
        {
          item: "Anti Ice",
          setting: "Off",
        },
        {
          item: "Fuel Pumps",
          setting: "Off",
        },
        {
          item: "Beacon",
          setting: "Off",
        },
        {
          item: "Nosewheel Steering Switch",
          setting: "Off",
        },
      ],
    },
    {
      title: "Terminating Check",
      roles: ["securing"],
      content: [
        {
          item: "Chocks and Brakes",
          setting: "In / Off",
        },
        {
          item: "IRS",
          setting: "Off",
        },
        {
          item: "Emergency Lights",
          setting: "Off",
        },
        {
          item: "Anti-Ice",
          setting: "Off",
        },
        {
          item: "Hydraulic Pumps",
          setting: "Off",
        },
        {
          item: "External Lights",
          setting: "Off",
        },
        {
          item: "APU",
          setting: "Off",
        },
        {
          item: "Battery Master",
          setting: "Off",
        },
        {
          item: "Cockpit Lights",
          setting: "Off",
        },
      ],
    },
  ],
};
